import React from "react"

type Props = {
    className?          : string

    projectId           : ID
    showEmptyRoot       : boolean
    maxFirstParents     : number
    showParentsOnly     : boolean
}

export default function ProjectPathProperty(props: Props) {
    let res: any

    const project = gd.session.projects.get(props.projectId)!
    let parents = []

    // add / as root
    if (!project.parentId && props.showEmptyRoot) {
        parents.push(<div key="more" className="more-parents">/</div>)
    }

    if (project.parentId) {
        // @ts-ignore
        const projectParents = gd.tree.findProjectParents(gd.tree.getProject(props.projectId)).concat(project).map((p:any) => p.name)
        if (props.showParentsOnly) projectParents.pop()
        parents = parents.concat(projectParents)
    }

    const parentsTotal = parents.length
    parents = parents.reverse()

    if (parentsTotal > 0) {
        let hasMoreParents = props.maxFirstParents && parents.length > props.maxFirstParents
        res = []

        // apply max parents
        if (hasMoreParents) parents = parents.slice(0,props.maxFirstParents)

        parents.map((parent, key) => {
            res.unshift(<div className="name max-w-80" key={gd.utils.generateUUID()}>{parent}</div>)

            if (key !== parentsTotal - 1)
                res.unshift(<div key={gd.utils.generateUUID()} className="ui5-triangle-toggle closed s6"/>)
        })

        if (hasMoreParents) res.unshift(<div key={gd.utils.generateUUID()} className="more-parents">...</div>)
    }

    const classes = Classes("ui5-project-path-property", props.className)

    if (_.isEmpty(res)) return null

    return (
        <div className={classes}>
            <div className="container">
                {res}
            </div>
        </div>
    )
}